import React from "react";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";

import logo from "../../assets/images/logo.svg";
import MenuItems from "./MenuItems";
import { routes } from "../../api/paths";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    logo: {
      marginRight: theme.spacing(4),
      width: 150,
    },
    appBar: {
      background: "#fff",
      color: theme.palette.primary.main,
      borderBottom: `5px solid ${theme.palette.primary.main}`,
    },
  })
);

type NavbarProps = {
  setSelectedRequest?: React.Dispatch<React.SetStateAction<number>>;
};

export default function Navbar({ setSelectedRequest }: NavbarProps) {
  const classes = useStyles();

  return (
    <AppBar position="sticky" className={classes.appBar}>
      <Toolbar>
        <a href={routes.RODILISTA_RODA_HR}>
          <img src={logo} alt="logo" className={classes.logo} />
        </a>
        <MenuItems setSelectedRequest={setSelectedRequest} />
      </Toolbar>
    </AppBar>
  );
}
